module.exports = __webpack_public_path__ + "static/img/member260112TW.eea9757.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member260112TW.jpg
// module id = AAOi
// module chunks = 1